import helper from "./helper";

let getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters
let getSurveyUrlWithParameters = helper.getSurveyUrlWithParameters
let getWorkerUrlWithParameters = helper.getWorkerUrlWithParameters
let getSurveyUrl = helper.getSurveyUrlWithParameters


export default {
    getSurveyUrl,
    SELECTORS: {
        FILE: {
            DOWNLOAD:
              /**
               * Получает URL для скачивания файла поля этапа
               * @param {number} id - Идентификатор файла
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для скачивания файла
               */
                (id, gets = null) => getSurveyUrl(
                    'stage_field|file',
                    "get",
                    {id: id},
                    gets
                ),
        },
        FILE_ANSWER: {
            DOWNLOAD:
              /**
               * Получает URL для скачивания файла ответа
               * @param {number} id - Идентификатор файла ответа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для скачивания файла ответа
               */
                (id, gets = null) => getSurveyUrl(
                    'answer|file',
                    "get",
                    {id: id},
                    gets
                ),
        },
        USERS: {
            ALL:
              /**
               * Получает URL для получения списка всех пользователей
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка пользователей
               */
              (gets = null) => getSurveyUrlWithParameters(
                "selectors|user",
                'get',
                {},
                gets
            )
        },
        WORKERS: {
            ALL:
              /**
               * Получает URL для получения списка всех работников
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка работников
               */
              (gets = null) => getWorkerUrlWithParameters(
                "selectors|employee|worker",
                'get',
                {},
                gets
            )
        },
        ADMIN: {
            FIELDS:
              /**
               * Получает URL для получения списка полей (административный режим)
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка полей
               */
              (gets = null) => getSurveyUrlWithParameters(
                'surveys|admin_survey|selectors|field',
                "get",
                {},
                gets
              ),
            CHOICES:
              /**
               * Получает URL для получения списка значений для выбора (административный режим)
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка значений
               */
              (gets = null) => getSurveyUrlWithParameters(
                'surveys|admin_survey|selectors|value_choices',
                "get",
                {},
                gets
              ),
        },
        CREATOR: {
            FIELDS:
              /**
               * Получает URL для получения списка полей (режим создателя)
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка полей
               */
              (gets = null) => getSurveyUrlWithParameters(
                'surveys|creator_survey|selectors|field',
                "get",
                {},
                gets
              ),
            CHOICES:
              /**
               * Получает URL для получения списка значений для выбора (режим создателя)
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка значений
               */
              (gets = null) => getSurveyUrlWithParameters(
                'surveys|creator_survey|selectors|value_choices',
                "get",
                {},
                gets
              ),
        }
    },
}
